
import axios from "axios";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop(Object) readonly episode!: any;
  @Prop(Function) readonly play!: any;
  @Prop(Function) readonly pause!: any;
  @Prop(Function) readonly seek!: any;
  @Prop(Number) readonly trackTime!: number;
  @Prop(Number) readonly currentTrackID!: number;
  @Prop(Array) readonly month!: Array<string>;
  @Prop(String) readonly id_share!: string;
  @Prop(String) readonly id_play!: string;

  isPressed = false;
  activeShare = false;
  fullname = "";
  playsCount = "";

  mounted() {
    document.addEventListener("click", this.hideSocial);
    axios
      .get(`https://api.spreaker.com/v2/episodes/${this.episode.episode_id}`)
      .then(({ data }) => {
        this.updatePodcast(data);
      });
  }
  updatePodcast({ response }: any) {
    const { episode } = response;
    this.playsCount = episode.plays_count;
    this.fullname = episode.author.fullname;
  }
  beforeDestroy() {
    document.removeEventListener("click", this.hideSocial);
  }
  hideSocial(e: any) {
    if (e.target != this.$refs.podcastShare) {
      this.activeShare = false;
    }
  }
  trackSeek(evt: EventListener, id: number) {
    this.$props.seek(evt, id);
  }
  trackPlay(src: string, trackId: number) {
    this.$props.play(src, trackId);
    this.isPressed = true;
  }
  trackPause(id: number) {
    this.isPressed = false;
    this.$props.pause(id);
  }
  dateFormated(date: string) {
    return new Date(date.replace(" ", "T"));
  }
  parseTime(time: number, duration: number) {
    const hours = ~~(time / 3600);
    const minutes = ~~((time / 60) % 60);
    const seconds = ~~(time % 60);
    const durationHours = ~~(duration / 3600 / 1000);
    return `${durationHours ? `${hours}:` : ""}${this.parseTimeHelper(
      minutes
    )}:${this.parseTimeHelper(seconds)}
    `;
  }
  parseTimeHelper(number: number) {
    return ("0" + number).slice(-2);
  }
  selectShare(episodeId: number) {
    this.activeShare = true;
  }
  socialNetworkRedirect(playback_url: string) {
    this.activeShare = false;
  }
}
